// FormFillerRouteWrapper.tsx

import React from "react";
import { useParams } from "react-router-dom";
import FormFillerPage from "./FormFillerPage";

const FormFillerRouteWrapper = () => {
  const { id } = useParams<{ id: string }>();

  return <FormFillerPage formId={Number(id)} />;
};

export default FormFillerRouteWrapper;
